import React, { useMemo, useState } from 'react';
import { InfoAlert } from 'src/components/atoms/alerts/InfoAlert';
import {
  DataBox,
  DataBoxBaseProps,
  DataBoxLegendProps,
} from 'src/components/molecules/DataBox';
import { NewAreaGraph } from 'src/components/molecules/graphs/NewAreaGraph';
import { useMMDataContext } from 'src/features/MM/contexts/MMDataContext';
import { EuroValueTickFormatter } from 'src/utils/TickFormatters';
import { MEDIA_INVESTMENT_DEF } from 'src/utils/metricDefinitions';
import { useAggregationLevelContext } from '../../contexts/AggregationLevelContext';
import { useGetDateAxisFormatter } from '../../hooks/useGetDateAxisFormatter';
import { getAggregateLevelData } from '../../utils/getAggregateLevelData';
import { TimeseriesDataTableModal } from '../molecules/TimeseriesDataTableModal';

const dataKeys = {
  xAxis: 'utcEpoch',
  data: ['value'],
};

const legendProps: DataBoxLegendProps = {
  placement: 'none',
  baseLegendKeys: dataKeys.data,
  labelMap: {
    value: 'Investment',
  },
};

export const MediaInvestmentBox: React.FC<DataBoxBaseProps> = ({
  ...props
}) => {
  const { investments } = useMMDataContext();
  const { aggregateLevel } = useAggregationLevelContext();
  const { isLoading, isError } = investments;

  const [infoOpen, setInfoOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const data = useMemo(() => {
    return getAggregateLevelData(investments, aggregateLevel);
  }, [investments, aggregateLevel]);

  const xAxisFormatter = useGetDateAxisFormatter();

  return (
    <>
      <InfoAlert
        headerText={props.title ?? ''}
        bodyText={MEDIA_INVESTMENT_DEF}
        isOpen={infoOpen}
        onClose={() => setInfoOpen(false)}
      />
      <DataBox
        {...props}
        onInfoButtonClick={() => setInfoOpen(true)}
        legendProps={legendProps}
        exportEnabled
        exportButtonEnabled={false}
        setTableDataModalIsOpen={setModalIsOpen}
        hasData={data.length > 0}
        isError={isError}
        isLoading={isLoading}>
        <>
          <TimeseriesDataTableModal
            isOpen={modalIsOpen}
            setIsOpen={setModalIsOpen}
            yFormatter={EuroValueTickFormatter}
            data={data}
            headerName={props.title ?? ''}
          />
          <NewAreaGraph
            data={data}
            xAxisKey={dataKeys.xAxis}
            xAxisFormatter={xAxisFormatter}
            yAxisFormatter={EuroValueTickFormatter}
          />
        </>
      </DataBox>
    </>
  );
};
